import React, {memo} from 'react';
import { BuyerInventoryReportVO } from "../../../types/model/valueObject/inventory/BuyerInventoryReportVO";
import { formatDriverName } from "../../../util/ReportUtils";
import {
  CollapsableCardBodyContainer,
  CollapsableCardClickableContainer,
  CollapsableCardCollapseContainer,
  CollapsableCardContainer,
  CollapsableCardExpandIconButton,
  CollapsableCardHeaderActionsContainer,
  CollapsableCardHeaderContainer,
  CollapsableCardHeaderItem,
  CollapsableCardBodyItem
} from "../../cardComponents";

type BuyerCurrentInventoryCardListItemProps = {
  item: BuyerInventoryReportVO;
  expanded?: boolean;
  onToggleExpand: () => void;
}

/**
 * Component that displays all information for a single Buyer current inventory item
 * @param item the BuyerInventoryReportVO to display
 * @param expanded
 * @param onToggleExpand
 * @constructor
 */


const BuyerCurrentInventoryCardListItemComponent = ({
  item,
  expanded,
  onToggleExpand
}: BuyerCurrentInventoryCardListItemProps) => {

  return (
    <CollapsableCardContainer expanded={expanded}>
      <CollapsableCardClickableContainer onClick={onToggleExpand}>
        <CollapsableCardHeaderContainer>
          <CollapsableCardHeaderItem value={item?.checkInDate} label={'Check In'} />
          <CollapsableCardHeaderItem value={item?.containerNumber} label={'Container'} />
          <CollapsableCardHeaderItem value={item?.trailerNumber} label={'Trailer'} />
          <CollapsableCardHeaderItem value={item?.chassisNumber} label={'Chassis'} />
          <CollapsableCardHeaderItem value={item?.orderNumber} label={'Booking'} />
          <CollapsableCardHeaderItem value={item?.locationName} label={'Location'} />
          <CollapsableCardHeaderActionsContainer>
            <CollapsableCardExpandIconButton expanded={expanded ?? false} />
          </CollapsableCardHeaderActionsContainer>
        </CollapsableCardHeaderContainer>
      </CollapsableCardClickableContainer>
      <CollapsableCardCollapseContainer in={expanded} mountOnEnter unmountOnExit={false}>
        <CollapsableCardBodyContainer>
          <CollapsableCardBodyItem value={item?.truckLicensePlateNumber} label={'Truck License Plate'} />
          <CollapsableCardBodyItem value={item?.chassisLicensePlateNumber} label={'Chassis License Plate'} />
          <CollapsableCardBodyItem value={item?.assetSize} label={'Size'} />
          <CollapsableCardBodyItem value={item?.sealNumber} label={'Seal'} />
          <CollapsableCardBodyItem value={item?.assetType} label={'Type'} />
          <CollapsableCardBodyItem value={item?.supplierName} label={'Supplier'} />
          <CollapsableCardBodyItem value={formatDriverName(item?.driverFirstName, item?.driverLastName)} label={'Driver'} />
          <CollapsableCardBodyItem value={item?.scacCode} label={'SCAC Code'} />
          <CollapsableCardBodyItem value={item?.notes} label={'Notes'} />
        </CollapsableCardBodyContainer>
      </CollapsableCardCollapseContainer>
    </CollapsableCardContainer>
  );
};

const BuyerCurrentInventoryCardListItem = memo(BuyerCurrentInventoryCardListItemComponent);

BuyerCurrentInventoryCardListItem.displayName = 'BuyerCurrentInventoryCardListItem';

export { BuyerCurrentInventoryCardListItem };
